<template>
  <div class="status-bar">
    <div class="left-section">
      <button class="menu-toggle" @click="toggleSidebar">
        <span class="menu-icon">☰</span>
      </button>
      <div class="logo">GenR</div>
    </div>
    <div class="theme-toggle" @click="toggleTheme">
      <i class="theme-icon">🌓</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusBar',
  methods: {
    toggleTheme() {
      document.body.classList.toggle('dark-mode');
    },
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    }
  }
}
</script>

<style scoped>
.status-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border-bottom: 1px solid var(--border-color);
}

.left-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.menu-toggle {
  display: none; /* 默认隐藏 */
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 1.5em;
  cursor: pointer;
  padding: 5px;
}

.logo {
  font-weight: bold;
  font-size: 1.2em;
}

.theme-toggle {
  cursor: pointer;
  padding: 5px;
}

.theme-icon {
  font-style: normal;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .menu-toggle {
    display: block;
  }
}

:global(body.dark-mode) .status-bar {
  background-color: #2d2d2d;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
</style> 